import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { succesMessage } from "../../../../../../../helpers/AssetsHelpers";
import {
  ajouterStrategiAnomaliePossible,
  getStrategieGlobaleMission,
} from "../../../../../../../data/stategieGlobale";
import { Button, Input, Tooltip, Typography } from "antd";
import { appTheme } from "../../../../../../../config/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileImport, faSave } from "@fortawesome/free-solid-svg-icons";
import { verifierExercicePrecedent } from "../../../../../../../data/exercice";

const { Title } = Typography;

const AnomaliePossible = ({
  mission,
  strategies,
  isProvisoire,
  codeSommaire,
  date,
  heureEntree,
  tache_id,
  intervention_id,
}) => {
  const [anomaliePossible, setAnomaliePossible] = useState("");
  const [loading, setLoading] = useState(false);
  const [exercicePrecedentData, setExercicePrecedentData] = useState(null);

  useEffect(() => {
    if (strategies && isProvisoire) {
      setAnomaliePossible(strategies.anomaliePossible || "");
    } else {
      setAnomaliePossible("");
    }
  }, [strategies, isProvisoire]);

  // Récupération de l'exercice précédent
  const fetchExercicePrecedent = async () => {
    await verifierExercicePrecedent(mission.id)
      .then((res) => {
        if (res?.status === "success" && res?.result) {
          setExercicePrecedentData(res.result);
        } else {
          setExercicePrecedentData(null);
        }
      })
      .catch((err) => {
        console.error("Erreur lors de la vérification:", err);
        setExercicePrecedentData(null);
      });
  };

  useEffect(() => {
    if (mission?.id) {
      fetchExercicePrecedent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mission?.id]);

  // Fonction pour vérifier si aucune donnée n'a été renseignée
  const hasNoData = () => {
    return !anomaliePossible || anomaliePossible.trim() === "";
  };

  // Fonction d'importation des données de l'exercice précédent
  const handleImport = async () => {
    // Vérification de sécurité
    if (!exercicePrecedentData?.id) {
      await swal("Erreur", "Aucun exercice précédent trouvé.", "error");
      return;
    }

    const result = await Swal.fire({
      title: '<strong style="font-size: 1.5em;">Êtes vous sûr ?</strong>',
      html: "Voulez-vous importer les anomalies possibles de l'exercice précédent ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d1ec51",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Annuler",
    });

    if (!result.isConfirmed) return;

    setLoading(true);
    try {
      // Récupérer la stratégie de l'exercice précédent
      const res = await getStrategieGlobaleMission(exercicePrecedentData.id);

      if (res?.result) {
        const strategyPrecedent = res.result.find(
          (item) => item.isProvisoire === isProvisoire
        );

        if (strategyPrecedent) {
          // Importer l'anomalie possible
          if (strategyPrecedent.anomaliePossible) {
            setAnomaliePossible(strategyPrecedent.anomaliePossible);

            await swal({
              title: "Importation effectuée avec succès",
              text: "Pensez à enregistrer les modifications.",
              icon: "success",
            });
          } else {
            await swal(
              "Aucune donnée trouvée",
              "Aucune anomalie possible trouvée pour l'exercice précédent.",
              "warning"
            );
          }
        } else {
          await swal(
            "Aucune donnée trouvée",
            `Aucune stratégie ${
              isProvisoire ? "provisoire" : "définitive"
            } trouvée pour l'exercice précédent.`,
            "error"
          );
        }
      } else {
        await swal(
          "Aucune donnée trouvée pour cet exercice précédent.",
          "",
          "error"
        );
      }
    } catch (error) {
      console.error("Erreur lors de l'importation:", error);
      await swal("Erreur lors de l'importation", "", "error");
    } finally {
      setLoading(false);
    }
  };

  const onChange = (e) => {
    setAnomaliePossible(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      anomaliePossible,
      exercice_id: mission.id,
      client_id: mission.client_id,
      codeSommaire,
      heureEntree,
      date,
      tache_id,
      intervention_id,
      isProvisoire,
    };

    const { status, message } = await ajouterStrategiAnomaliePossible(data);
    if (status === "success") {
      setLoading(false);
      await swal(succesMessage, "", "success");
    } else {
      setLoading(false);
      await swal(message, "", "error");
    }
  };

  return (
    <div className="d-flex flex-column fv-plugins-bootstrap5 fv-plugins-framework pb-10">
      <div className="d-flex justify-content-end align-items-end mb-10 gap-2">
        {/* Bouton Importer */}
        {exercicePrecedentData && hasNoData() && (
          <Tooltip title="Importer les données de l'année précédente">
            <Button
              disabled={
                mission.isCloture === 1 || mission.isClotureProvisoire === 1
              }
              loading={loading}
              size={"large"}
              style={{
                backgroundColor: appTheme.colors.primary,
                color: "white",
              }}
              icon={
                <FontAwesomeIcon
                  style={{ paddingRight: "10" }}
                  icon={faFileImport}
                />
              }
              onClick={handleImport}
            >
              {!loading && (
                <span className="indicator-label text-white">Importer</span>
              )}
              {loading && (
                <span className="indicator-progress text-white">
                  Importation...
                </span>
              )}
            </Button>
          </Tooltip>
        )}

        {/* Bouton Enregistrer */}
        <Tooltip title="Enregistrer">
          <Button
            disabled={
              mission.isCloture === 1 || mission.isClotureProvisoire === 1
            }
            size={"large"}
            loading={loading}
            style={{
              backgroundColor: appTheme.colors.secondary,
              color: "white",
            }}
            icon={
              <FontAwesomeIcon style={{ paddingRight: "10" }} icon={faSave} />
            }
            onClick={handleSubmit}
          >
            {!loading && (
              <span className="indicator-label text-white">Enregistrer</span>
            )}
            {loading && (
              <span className="indicator-progress text-white">
                Patientez svp...
              </span>
            )}
          </Button>
        </Tooltip>
      </div>

      <div className="card-header">
        <div className="card-title">
          <Title
            style={{
              display: "block",
              fontWeight: "600",
              color: appTheme.colors.primary,
            }}
            level={4}
          >
            {"Anomalies possibles dans les informations qualitatives"}
          </Title>
        </div>
      </div>
      <div className="mt-5"></div>
      <Input.TextArea
        size="large"
        placeholder="Saissiser l'anomalie possible"
        readOnly={mission.isCloture === 1 || mission.isClotureProvisoire === 1}
        maxLength={5000}
        showCount
        autoSize={{
          minRows: 8,
          maxRows: 25,
        }}
        value={anomaliePossible}
        onChange={onChange}
      />
    </div>
  );
};

export default AnomaliePossible;
